import { render, staticRenderFns } from "./GroupResults.vue?vue&type=template&id=7245cae4&"
import script from "./GroupResults.vue?vue&type=script&lang=tsx&"
export * from "./GroupResults.vue?vue&type=script&lang=tsx&"
import style0 from "./GroupResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7245cae4')) {
      api.createRecord('7245cae4', component.options)
    } else {
      api.reload('7245cae4', component.options)
    }
    module.hot.accept("./GroupResults.vue?vue&type=template&id=7245cae4&", function () {
      api.rerender('7245cae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/search/results/table/GroupResults.vue"
export default component.exports